// extracted by mini-css-extract-plugin
export default {"root":"EntityCard_root__HnvEL","hoverVisible":"EntityCard_hoverVisible__w+xe5"};